import Data from "../types/Data";

export default function hasPeople(data: Data) {
  return data.personIds.length > 0;
}
